module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBold.bb3740d3.otf";